import { Control, Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useCallback, useEffect } from 'react';
import { FormControlLabel, Switch } from '@mui/material';
import { Button, Input, Upload } from '../../../../../../components';
import ShopGroup from '../../../../../../entities/shop-group.entity';
import useStyles from './styles';
import { schema, ShopGroupForm } from '../../../../../../validations/shop-group.validation';
import { clone } from '../../../../../../utils/helpers';
import { RecursiveKeyOf } from '../../../../../../utils/types';

interface FormShopGroup {
  shopGroup: ShopGroup;
  fileToUpload?: File | null;
  handleUpload: (file: File | null) => void;
  onSubmit: (input: ShopGroup | undefined) => unknown;
  handleFieldChange: (target: RecursiveKeyOf<ShopGroup>, value: string | boolean | number | null) => void;
}

export const Form = ({
  onSubmit,
  shopGroup,
  fileToUpload,
  handleUpload,
  handleFieldChange,
}: FormShopGroup): JSX.Element => {
  const styles = useStyles();
  const {
    register,
    reset,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
  } = useForm<ShopGroup>({
    resolver: yupResolver(schema),
    defaultValues: shopGroup,
  });

  const validationRegister = useCallback(
    (name: RecursiveKeyOf<ShopGroupForm>, isNumber?: boolean) =>
      register(name as keyof ShopGroupForm, {
        onChange: (e) => handleFieldChange(name, isNumber ? Number(e.target.value) : e.target.value),
      }),
    [register, handleFieldChange]
  );

  useEffect(() => {
    reset(clone(shopGroup));
  }, [shopGroup, reset]);

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.left}>
            <Upload file={fileToUpload || shopGroup.imageUrl} onUpload={handleUpload} />
          </div>
          <div className={styles.right}>
            <div className={styles.line}>
              <Input
                placeholder="Grupo de loja"
                label="nome do grupo*"
                validationRegister={validationRegister('label')}
                fullWidth
                error={Boolean(errors.label)}
                helperText={errors.label?.message || ' '}
              />
              <Input
                placeholder="1"
                label="posição"
                validationRegister={validationRegister('position', true)}
                type="number"
                fullWidth
                error={Boolean(errors.position)}
                helperText={errors.position?.message || ' '}
              />
              <Controller
                name="isDisabled"
                control={control}
                render={({ field }) => (
                  <FormControlLabel
                    label="desativar grupo"
                    control={
                      <Switch checked={field.value ?? false} onChange={(_, newValue) => field.onChange(newValue)} />
                    }
                  />
                )}
              />
            </div>
          </div>
        </div>
        <div className={styles.footer}>
          <Button sx={{ width: '200px' }} loading={isSubmitting} type="submit">
            Salvar
          </Button>
        </div>
      </div>
    </form>
  );
};

export default Form;
